define('app/sf/join/sf-join-filter',[],function () {
	"use strict";
	return sfJoinFilter;
	function sfJoinFilter(value, separator) {
		if (angular.isArray(value)) {
			return value.join(separator);
		}
		else if (angular.isUndefined(value) || value === null) {
			return "";
		}
		else {
			return String(value);
		}
	}
});
